var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.207,
    height: 6.224,
    viewBox: "0 0 6.207 6.224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#005699;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.567 -3.567)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.567 3.567)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.258,4.258H.447A.447.447,0,0,1,0,3.811V.447A.447.447,0,0,1,.447,0H3.258a.447.447,0,0,1,.447.447V3.811A.447.447,0,0,1,3.258,4.258Zm-2.767-.4.017.017V3.811H3.258L3.249.447H.468L.447,3.811l.017.018a.052.052,0,0,0,.012.038.014.014,0,0,0,.009.006s.006,0,.006-.014Z",
    transform: "translate(0 1.967)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.258,4.258H1.5V3.811H3.258V.509h.063L3.276.464c0-.01-.009-.018-.013-.018l0,0,0,0H.447V1.69H0V.447A.441.441,0,0,1,.131.132.446.446,0,0,1,.447,0H3.258a.443.443,0,0,1,.315.131.447.447,0,0,1,.132.316V3.811a.443.443,0,0,1-.131.315l0,0A.446.446,0,0,1,3.258,4.258Z",
    transform: "translate(2.502 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnCopy);
export default __webpack_public_path__ + "static/media/BTN_Copy.eadde37f88099c0f348b82c41bf4d3f9.svg";
export { ForwardRef as ReactComponent };